import React from 'react';
import { useIntl } from 'react-intl';

import { RadioCheckListItem } from 'ui-components/components/radio-check-list/radio-check-list-item';
import { Text, TextType } from 'ui-components/components/text';

import { MonthValues } from '../constants';
import { messages } from './messages';
import style from './style.module.less';

/**
 * All possible values a user can select.
 * They represent months.
 */
const ExpirationValues = [MonthValues.Twelve, MonthValues.Six, MonthValues.Three];

/**
 * This component renders a couple to Radio inputs to select the expiration Date
 * @param {object} props
 * @param {string} props.selected - Selected values
 * @param {(selected: string) => void} props.onSelected - Callback when the user clicks another expiration time
 * @returns {JSX.Element} The rendered component.
 */
export const CreateForm = ({ selected, onSelected }) => {
  const intl = useIntl();
  const onRadioValueChange = ({ target: { value } }) => onSelected(value);

  const getRadioLabel = (/** @type {string} */ expirationValue) => {
    switch (expirationValue) {
      case MonthValues.Twelve:
        return messages.label12Months;
      case MonthValues.Six:
        return messages.label6Months;
      default:
        return messages.label3Months;
    }
  };

  return (
    <>
      <Text element='label' textType={TextType.Label} value={messages.formHeaderLabel} />

      {ExpirationValues.map((expirationValue) => (
        <RadioCheckListItem
          key={expirationValue}
          className={style['v1-create-form-radio-input']}
          isChecked={selected === expirationValue}
          name='apiV1Expiration'
          onChecked={onRadioValueChange}
          value={expirationValue}
        >
          {intl.formatMessage(getRadioLabel(expirationValue))}
        </RadioCheckListItem>
      ))}
    </>
  );
};
